$(document).on('turbo:load', () => {
  let filterSection = () => {

    let $doc = $(document);
    let $filterBtn = $doc.find('#filter-search');
    let $filterBox = $doc.find('.filter-box');
    let $applyBtn = $doc.find('#apply-filter');
    let $resetBtn = $doc.find('#reset-filter');
    // let $tagsBtn = $doc.find('.filter-tags button');

    // remove event handlers if they were on and re-add them
    // strange behavior when user exports causes the filter toggle to repeatedly open/close
    // removing the handlers should prevent this

    $filterBtn.off('click');
    $applyBtn.off('click');
    $resetBtn.off('click');

    $filterBtn.on('click', (e) => {
      e.preventDefault();
      $filterBox.toggle();
    });

    $applyBtn.on('click', (e) => {
      e.preventDefault();
      $filterBox.hide();
    });

    // $resetBtn.on('click', (e) => {
    //   e.preventDefault();
    //   $filterBox.slideUp(500);
    // });

    // $tagsBtn.on('click', (e) => {
    //   e.preventDefault();
    //   console.log();
    //   $(e.currentTarget).closest('li').remove();
    // });

  };

  filterSection();

});